import React from 'react'
import { Text } from 'theme-ui'

import {
  ProductInfoStyled,
  ProductInfoMediasStyled,
  ProductInfoContentStyled,
  ProductInfoTitleStyled,
  ProductInfoDescriptionStyled,
  ProductInfoCtaStyled,
  ProductInfoCtaCaptionStyled,
  ProductInfoCaptionStyled,
  ProductInfoDemoLinkStyled,
  ProductInfoContentWrapperStyled
} from './styles'

import Button from './../../atoms/Button'
import ProductInfoMedia from './../../molecules/ProductInfoMedia'
import { ProductInfoProps } from './types'

const ProductInfo: React.FC<ProductInfoProps> = ({ data }) => {
  const { title, description, cta, demo, caption, mediaBlock } = data

  return (
    <ProductInfoStyled>
      {mediaBlock && (
        <ProductInfoMediasStyled>
          <ProductInfoMedia data={mediaBlock} />
        </ProductInfoMediasStyled>
      )}
      <ProductInfoContentStyled>
        <ProductInfoContentWrapperStyled>
          {title && (
            <ProductInfoTitleStyled>
              <Text
                as="p"
                sx={{
                  variant: 'headingRaleway6',
                  fontFamily: 'secondary'
                }}
              >
                {title}
              </Text>
            </ProductInfoTitleStyled>
          )}
          {description && (
            <ProductInfoDescriptionStyled>
              <Text as="div" variant="bodyMontserrat8" dangerouslySetInnerHTML={{ __html: description }} />
            </ProductInfoDescriptionStyled>
          )}
          {cta && (
            <ProductInfoCtaStyled>
              <Button variant="isLarge" {...cta} />
              {demo && (
                <ProductInfoCtaCaptionStyled>
                  <Text
                    sx={{
                      variant: 'bodyRaleway4',
                      fontFamily: 'secondary'
                    }}
                  >
                    {`${demo.prefix} `}
                    <ProductInfoDemoLinkStyled href={demo.url} target="_blank" rel="noreferrer noopener">
                      {demo.urlText}
                    </ProductInfoDemoLinkStyled>
                  </Text>
                </ProductInfoCtaCaptionStyled>
              )}
            </ProductInfoCtaStyled>
          )}
          {/* {caption && (
            <ProductInfoCaptionStyled>
              <Text variant="bodyMontserrat7">{caption}</Text>
            </ProductInfoCaptionStyled>
          )} */}
        </ProductInfoContentWrapperStyled>
      </ProductInfoContentStyled>
    </ProductInfoStyled>
  )
}

export default ProductInfo
